import { motion } from "framer-motion";
import { ArrowRight, MapPin } from "lucide-react";
import { Button } from "./ui/button";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_32aa2cdc-2128-46e1-b78d-17029247dee5/artifacts/q6wuaspw_ChatGPT%20Image%20Feb%203%2C%202026%2C%2006_33_23%20PM.png";

const Hero = () => {
  const scrollToContact = (e) => {
    e.preventDefault();
    const element = document.querySelector("#contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center bg-white pt-20" data-testid="hero-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="order-2 lg:order-1"
          >
            <div className="flex items-center gap-2 mb-6">
              <MapPin className="w-4 h-4 text-[#525252]" />
              <span className="text-sm text-[#525252] tracking-wider">
                ADELAIDE & SOUTH AUSTRALIA
              </span>
            </div>

            <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl font-bold text-[#0a0a0a] leading-[1.1] mb-6">
              SEAL IT
              <br />
              <span className="text-[#525252]">RIGHT</span>
            </h1>

            <p className="text-lg text-[#525252] mb-8 max-w-lg leading-relaxed">
              Professional caulking services for your home. We specialize in bathroom, 
              kitchen, window, and door sealing that lasts.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                size="lg"
                className="bg-[#0a0a0a] text-white hover:bg-[#171717] font-heading tracking-wider btn-primary text-base px-8 py-6"
                onClick={scrollToContact}
                data-testid="hero-get-quote-btn"
              >
                GET FREE QUOTE
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
              <Button
                size="lg"
                variant="outline"
                className="border-[#0a0a0a] text-[#0a0a0a] hover:bg-[#0a0a0a] hover:text-white font-heading tracking-wider text-base px-8 py-6"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector("#services").scrollIntoView({ behavior: "smooth" });
                }}
                data-testid="hero-services-btn"
              >
                OUR SERVICES
              </Button>
            </div>

            {/* Stats */}
            <div className="mt-12 grid grid-cols-3 gap-8">
              <div>
                <p className="font-heading text-3xl font-bold text-[#0a0a0a]">100+</p>
                <p className="text-sm text-[#525252]">Projects Completed</p>
              </div>
              <div>
                <p className="font-heading text-3xl font-bold text-[#0a0a0a]">4+</p>
                <p className="text-sm text-[#525252]">Years Experience</p>
              </div>
              <div>
                <p className="font-heading text-3xl font-bold text-[#0a0a0a]">100%</p>
                <p className="text-sm text-[#525252]">Satisfaction</p>
              </div>
            </div>
          </motion.div>

          {/* Right Content - Logo/Image */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="order-1 lg:order-2 flex justify-center lg:justify-end"
          >
            <div className="relative">
              <div className="w-72 h-72 sm:w-96 sm:h-96 lg:w-[450px] lg:h-[450px] bg-[#f5f5f5] rounded-full flex items-center justify-center">
                <img
                  src={LOGO_URL}
                  alt="Ultimate Caulking Company"
                  className="w-56 h-56 sm:w-72 sm:h-72 lg:w-80 lg:h-80 object-contain"
                  data-testid="hero-logo"
                />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
